import { Component, OnInit, Injector, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { WorkOrdersService } from '../../work-orders.service';
import { BodyWorkOrderService } from '../../../ve.service';

@Component({
  selector: 'body-wo-add',
  templateUrl: './body-wo-add.component.html',
  styleUrls: ['./body-wo-add.component.scss', '../../work-orders.component.scss']
})
export class BodyWoAddComponent implements OnInit, OnDestroy {
  appCardTitle: string;
  router: Router;
  service: WorkOrdersService;
  bodyWorkOrderService: BodyWorkOrderService;

  constructor(injector: Injector) {
    this.service = injector.get(WorkOrdersService);
    this.bodyWorkOrderService = injector.get(BodyWorkOrderService);
    this.appCardTitle = 'Add New Body Work Order';
    this.router = injector.get(Router);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
    this.service.resetForm();
    this.service.enableForm();
    this.service.resetGridView();
  }

  saveOrSubmit(event: any) {
    const action = event.currentTarget.id;
    const workOrder = this.service.bodyMainEditForm.value;
    this.service.saveOrSubmit(action, workOrder);
  }

  public get isFormValid(): boolean {
    return this.service.bodyMainEditForm.valid;
  }

  back = () => {
    const bodyWorkOrder = this.service.bodyMainEditForm.value;
    this.service.back(bodyWorkOrder, false);
  }

  cancel() {
    const bodyWorkOrder = this.service.bodyMainEditForm.value;
    this.service.back(bodyWorkOrder, true);
  }
}
